import { hasAuthorization } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { type FavoritesResponse } from '@pkgs/api/models';
import { getFavorites as generatedGetFavorites } from '@generated/search-bff/controllers/favorites/favorites';

/**
 * Get favorites for an account.
 * Requires a valid JWT token in the `apiConfig`.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/favorites/getFavorites Search API Documentation}
 */
export async function getFavorites(apiConfig: ApiConfig): Promise<ApiResult<FavoritesResponse>> {
  if (!hasAuthorization(apiConfig)) {
    console.warn(
      'JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`',
    );
  }

  try {
    const response = await generatedGetFavorites(apiConfig);
    return {
      status: 'success',
      data: response,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
